import type { MessageKey } from "./en";
import { auth } from "./m/auth";
import { common } from "./m/common";
import { crm } from "./m/crm";
import { wp04 } from "./m/wp04";
import { wp05 } from "./m/wp05";
import { wp06 } from "./m/wp06";
import { wp07 } from "./m/wp07";
import { website } from "./m/website";
import { builder } from "./m/builder";
import { mobile } from "./m/mobile";
import { ui } from "./m/ui";
import { ops } from "./m/ops";
import { owner } from "./m/owner";
import { setup } from "./m/setup";
import { errors } from "./m/errors";
import { drawer } from "./m/drawer";
import { waSetup } from "./m/wa-setup";
import { waEmbedded } from "./m/wa-embedded";
import { member } from "./m/member";
import { shop } from "./m/shop";
import { shopG } from "./m/shop-g";
import { ai } from "./m/ai";
import { memberSite } from "./m/member-site";
import { taskM } from "./m/task-m";
import { taskN } from "./m/task-n";
import { taskO } from "./m/task-o";
import { taskP } from "./m/task-p";
import { taskQ } from "./m/task-q";
import { taskS } from "./m/task-s";
import { taskT } from "./m/task-t";
import { taskV } from "./m/task-v";
import { taskU } from "./m/task-u";
import { taskW } from "./m/task-w";
import { taskX } from "./m/task-x";
import { taskZ } from "./m/task-z";
import { taskBB } from "./m/task-bb";
import { taskDD } from "./m/task-dd";
import { taskDD2 } from "./m/task-dd2";
import { taskEE } from "./m/task-ee";
import { taskFF } from "./m/task-ff";
import { taskHH } from "./m/task-hh";
import { taskJJ } from "./m/task-jj";
import { taskKK } from "./m/task-kk";
import { taskLL } from "./m/task-ll";
import { taskNN } from "./m/task-nn";
import { taskEM } from "./m/task-em";
import { taskSF } from "./m/task-sf";
import { taskDR } from "./m/task-dr";
import { taskSC } from "./m/task-sc";
import { taskSG } from "./m/task-sg";
import { taskPG } from "./m/task-pg";
import { taskAN } from "./m/task-an";
import { taskHS } from "./m/task-hs";
import { taskQR } from "./m/task-qr";
import { taskSEC } from "./m/task-sec";
import { taskWL } from "./m/task-wl";
import { taskPM } from "./m/task-pm";
import { taskROT } from "./m/rotation";
import { taskWP } from "./m/task-wp";
import { taskAX } from "./m/task-ax";
import { taskOT } from "./m/overtime";
import { taskIV } from "./m/invite-verify";
import { taskROS } from "./m/roster";
import { taskPH } from "./m/phone";
import { taskTIP } from "./m/tips";
import { taskTAXPAY } from "./m/taxpay";
import { taskWZ } from "./m/wizard";
import { taskGD } from "./m/guide";
import { taskWAC } from "./m/wa-center";
import { siteImg } from "./m/site-img";
import { taskMM } from "./m/task-mm";
import { taskAA } from "./m/task-aa";
import { taskY } from "./m/task-y";

export const ms: Record<MessageKey, string> = { ...common.ms, ...auth.ms, ...setup.ms, ...owner.ms, ...ops.ms, ...crm.ms, ...wp04.ms, ...wp05.ms, ...wp06.ms, ...wp07.ms, ...website.ms, ...builder.ms, ...mobile.ms, ...ui.ms, ...errors.ms, ...drawer.ms, ...waSetup.ms, ...waEmbedded.ms, ...member.ms, ...shop.ms, ...shopG.ms, ...memberSite.ms, ...ai.ms, ...taskM.ms, ...taskN.ms, ...taskO.ms, ...taskP.ms, ...taskQ.ms, ...taskS.ms, ...taskT.ms, ...taskV.ms, ...taskU.ms, ...taskW.ms, ...taskX.ms, ...taskZ.ms, ...taskAA.ms, ...taskY.ms, ...taskBB.ms, ...taskDD.ms, ...taskDD2.ms, ...taskEE.ms, ...taskFF.ms, ...taskHH.ms, ...taskJJ.ms, ...taskKK.ms, ...taskLL.ms, ...taskMM.ms, ...taskNN.ms, ...taskEM.ms, ...taskSF.ms, ...taskDR.ms, ...taskSC.ms, ...taskSG.ms, ...taskPG.ms, ...taskAN.ms, ...taskHS.ms, ...taskQR.ms, ...taskSEC.ms, ...taskWL.ms, ...taskPM.ms, ...taskWP.ms, ...taskAX.ms, ...taskROT.ms, ...taskOT.ms, ...taskIV.ms, ...taskROS.ms, ...taskPH.ms, ...siteImg.ms, ...taskTIP.ms, ...taskTAXPAY.ms, ...taskWZ.ms, ...taskGD.ms, ...taskWAC.ms };
